
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(11065|21541|25034|33446|43922|55827|66303|76779|78208|88684)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
